import {useCallback, useEffect, useState} from "react";
import {getBackendErrorMessage} from "../../shared/utils/httpError";
import {getRegua, listCobrancas} from "./FinanceiroService";
import {normalizarPaginaDeCobrancas, parametrosDaLista} from "./cobrancasUtils";

/*
 * A tela de cobranças (BBF-158): a régua de inadimplência e a lista de todas as cobranças, com filtros e páginas.
 */
export function useCobrancas() {
    const [regua, setRegua] = useState({linhas: [], carregando: true, erro: ''});
    const [filtros, setFiltros] = useState({filtro: '', meio: '', empresaId: '', pagina: 1, limite: 10});
    const [lista, setLista] = useState({itens: [], total: 0, paginas: 0, pagina: 1, limite: 10, carregando: true, erro: ''});

    const carregarRegua = useCallback(async () => {
        setRegua((atual) => ({...atual, carregando: true, erro: ''}));
        try {
            const response = await getRegua();
            setRegua({linhas: Array.isArray(response?.data) ? response.data : [], carregando: false, erro: ''});
        } catch (error) {
            setRegua({linhas: [], carregando: false, erro: getBackendErrorMessage(error, 'Não foi possível carregar a régua.')});
        }
    }, []);

    const carregarLista = useCallback(async () => {
        setLista((atual) => ({...atual, carregando: true, erro: ''}));
        try {
            const response = await listCobrancas(parametrosDaLista(filtros));
            setLista({...normalizarPaginaDeCobrancas(response?.data), carregando: false, erro: ''});
        } catch (error) {
            setLista((atual) => ({...atual, itens: [], carregando: false, erro: getBackendErrorMessage(error, 'Não foi possível carregar as cobranças.')}));
        }
    }, [filtros]);

    useEffect(() => {
        carregarRegua();
    }, [carregarRegua]);

    useEffect(() => {
        carregarLista();
    }, [carregarLista]);

    // Mudar um filtro volta para a primeira página.
    const mudarFiltro = useCallback((campo, valor) => {
        setFiltros((atual) => ({...atual, [campo]: valor, pagina: campo === 'pagina' ? valor : 1}));
    }, []);

    const recarregar = useCallback(async () => {
        await Promise.all([carregarRegua(), carregarLista()]);
    }, [carregarRegua, carregarLista]);

    return {regua, filtros, lista, mudarFiltro, recarregar};
}
